import ArrowBackIcon from "@mui/icons-material/ArrowBackRounded";
import { Dialog, DialogContent, DialogTitle, Divider, IconButton } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { PropsWithChildren } from "react";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import WidgetFootnoteButton from "./WidgetFootnoteButton";
import WidgetListToolbar from "./WidgetListToolbar";

interface Props {
  widgetSettings: PortalWidget;
  onSearch: (value: string) => void;
  onOpenFilters: () => void;
  onClose: () => void;
  rowCount: number;
  loading?: boolean;
  isAnyFilterApplied?: boolean;
  filterText?: string;
}

const backButtonSx: SxProps<Theme> = { position: "absolute", left: 12, top: 12 };

const footnoteButtonSx: SxProps<Theme> = { position: "absolute", right: 12, top: 12 };

const WidgetListDialog = ({
  widgetSettings,
  onSearch,
  onOpenFilters,
  onClose,
  rowCount,
  loading,
  isAnyFilterApplied,
  filterText,
  children,
}: PropsWithChildren<Props>) => (
  <Dialog open fullScreen>
    <DialogTitle sx={{ textAlign: "center", px: 7 }}>{widgetSettings.name}</DialogTitle>
    <IconButton aria-label="back" sx={backButtonSx} onClick={onClose}>
      <ArrowBackIcon />
    </IconButton>
    {widgetSettings.footnote && <WidgetFootnoteButton text={widgetSettings.footnote} sx={footnoteButtonSx} />}
    <Divider />
    <WidgetListToolbar
      onSearch={onSearch}
      onOpenFilters={onOpenFilters}
      rowCount={rowCount}
      loading={loading}
      isAnyFilterApplied={isAnyFilterApplied}
      filterText={filterText}
    />
    <Divider />
    <DialogContent sx={{ px: 1.5, py: 1.5 }}>{children}</DialogContent>
  </Dialog>
);

export default WidgetListDialog;
